module.exports = __webpack_public_path__ + "static/media/User_gray.36af01c9.svg";